import { Container, ContainerMetadata } from '../types/canvas.types';

class ContainerStore {
  private static instance: ContainerStore;
  private containerMetadataMap: Map<string, ContainerMetadata> = new Map();
  private containerHierarchy: Map<string, string> = new Map();

  private constructor() {}

  static getInstance(): ContainerStore {
    if (!ContainerStore.instance) {
      ContainerStore.instance = new ContainerStore();
    }
    return ContainerStore.instance;
  }

  registerContainers(containers: Container[]): void {
    const processContainers = (containerList: Container[], parentId?: string) => {
      containerList.forEach(container => {
        if (container.metadata) {
          this.containerMetadataMap.set(container.id, container.metadata);
        } else {
          const isNested = !!parentId;
          this.containerMetadataMap.set(container.id, {
            type: isNested ? 'nested-container' : 'container',
            isNested: isNested,
            parentContainerId: parentId,
          });
        }

        if (parentId) {
          this.containerHierarchy.set(container.id, parentId);
        }

        if (container.content.nestedContainers && container.content.nestedContainers.length > 0) {
          processContainers(container.content.nestedContainers, container.id);
        }
      });
    };
    
    this.containerMetadataMap.clear();
    this.containerHierarchy.clear();
    
    processContainers(containers);
  }

  isContainerNested(containerId: string): boolean {
    const metadata = this.containerMetadataMap.get(containerId);
    return metadata?.isNested === true;
  }

  getContainerMetadata(containerId: string): ContainerMetadata | undefined {
    return this.containerMetadataMap.get(containerId);
  }

  getRootContainerId(containerId: string): string {
    let currentId = containerId;
    let parentId = this.containerHierarchy.get(currentId);
    
    while (parentId) {
      currentId = parentId;
      parentId = this.containerHierarchy.get(currentId);
    }
    
    return currentId;
  }

  getDescendantContainers(parentId: string): string[] {
    const descendants: string[] = [];
    
    this.containerHierarchy.forEach((parent, child) => {
      if (parent === parentId || this.getRootContainerId(child) === parentId) {
        descendants.push(child);
      }
    });
    
    return descendants;
  }

  clear(): void {
    this.containerMetadataMap.clear();
    this.containerHierarchy.clear();
  }
}

export const containerStore = ContainerStore.getInstance();